export default __webpack_public_path__ + "static/media/investment.c9823109.svg";